<div
  class="bg-red-4 font-roboto-500 text-16 rounded-5 p-5 text-grey-1 mb-3 max-sm:text-13 max-sm:p-3 mt-5 max-sm:mt-2"
>
  {{ titleIncident | translate }}
</div>

<div class="flex flex-col gap-5">
  <ng-container *ngFor="let incident of incidentsMatch; let i = index">
    <div
      class="flex items-center gap-2"
      [ngClass]="{ 'flex-row-reverse': incident.position.code === 2 }"
    >
      <div
        *ngIf="!isPenaltys"
        class="font-roboto-600 text-grey-2 max-w-[20px] w-full text-16"
      >
        {{ incident.time }}'
      </div>
      <img
        alt="incident-type"
        class="object-contain"
        [ngClass]="{
          'w-[17px]': incident.type.code != 3 && incident.type.code != 4,
          'w-[12px]': incident.type.code === 3 || incident.type.code === 4,
          'w-[20px]': incident.type.code === 28 || incident.type.code === 15
        }"
        *ngIf="
          incident.type.code != 1 &&
          incident.type.code != 8 &&
          incident.type.code != 16 &&
          incident.type.code != 17 &&
          incident.type.code != 29 &&
          incident.type.code != 30
        "
        [src]="incident.type.svg"
      />
      <div
        class="flex items-center gap-1"
        *ngIf="
          incident.type.code === 1 ||
          incident.type.code === 8 ||
          incident.type.code === 16 ||
          incident.type.code === 17 ||
          incident.type.code === 29 ||
          incident.type.code === 30
        "
      >
        <img alt="incident" class="object-contain" [src]="incident.type.svg" />
        <span class="font-roboto-700 text-18 text-nowrap">
          {{ incident.homeScore }} - {{ incident.awayScore }}
        </span>
      </div>
      <div
        nz-col
        nzSpan="{{
          incident.type.code != 1 &&
          incident.type.code != 8 &&
          incident.type.code != 16 &&
          incident.type.code != 17 &&
          incident.type.code != 29 &&
          incident.type.code != 30
            ? 20
            : 16
        }}"
        class="text-incident gap-2 max-sm:gap-1"
        [ngClass]="{
          'inline-flex': [1, 8, 16, 17, 29, 30].includes(incident.type.code),
          grid: ![1, 8, 16, 17, 29, 30].includes(incident.type.code),
          'text-left':
            ![11, 12, 19, 26, 27].includes(incident.type.code) &&
            incident.position.code !== 2,
          'text-right': incident.position.code === 2,
          'justify-start':
            ![11, 12, 19, 26, 27].includes(incident.type.code) &&
            incident.position.code !== 2,
          'justify-end': incident.position.code === 2
        }"
      >
        <!-- Gol incident -->
        <span
          class="text-grey-2 font-roboto-500"
          *ngIf="
            ((incident.assit1Id && incident.assit1Id != '') ||
              (incident.assit2Id && incident.assit2Id != '')) &&
            incident.position.code === 2 &&
            incident.type.code === 1
          "
        >
          ({{
            incident.assit1Id
              ? incident.assist1NameShort != ""
                ? incident.assist1NameShort
                : incident.assist1Name
              : incident.assist2NameShort != ""
              ? incident.assist2NameShort
              : incident.assist2Name
          }})
        </span>
        <span
          class="font-roboto-600 text-14"
          *ngIf="incident.type.code === 1 || incident.type.code === 8"
        >
          {{
            incident.playerNameShort != ""
              ? incident.playerNameShort
              : incident.playerName
          }}
        </span>
        <span
          class="text-grey-2 font-roboto-500"
          *ngIf="
            ((incident.assit1Id && incident.assit1Id != '') ||
              (incident.assit2Id && incident.assit2Id != '')) &&
            incident.position.code === 1 &&
            incident.type.code === 1
          "
        >
          ({{
            incident.assit1Id
              ? incident.assist1NameShort != ""
                ? incident.assist1NameShort
                : incident.assist1Name
              : incident.assist2NameShort != ""
              ? incident.assist2NameShort
              : incident.assist2Name
          }})
        </span>

        <!-- Penalty in time regular or overtime -->
        <span
          class="text-grey-2 font-roboto-500"
          *ngIf="
            incident.position.code === 1 &&
            (incident.type.code === 16 || incident.type.code === 17)
          "
        >
          {{
            incident.playerNameShort != ""
              ? incident.playerNameShort
              : incident.playerName
          }}
          ({{ incident.type.text }})
        </span>
        <span
          class="text-grey-2 font-roboto-500"
          *ngIf="
            incident.position.code === 2 &&
            (incident.type.code === 16 || incident.type.code === 17)
          "
        >
          ({{ incident.type.text }})
          {{
            incident.playerNameShort != ""
              ? incident.playerNameShort
              : incident.playerName
          }}
        </span>

        <!-- Penaltys shootout Report -->
        <span
          class="font-roboto-600"
          *ngIf="incident.position.code === 1 && incident.type.code === 29"
        >
          {{
            incident.playerNameShort != ""
              ? incident.playerNameShort
              : incident.playerName
          }}
        </span>
        <span
          class="font-roboto-600"
          *ngIf="incident.position.code === 2 && incident.type.code === 29"
        >
          {{
            incident.playerNameShort != ""
              ? incident.playerNameShort
              : incident.playerName
          }}
        </span>
        <span
          class="text-grey-2 font-roboto-500"
          *ngIf="incident.position.code === 1 && incident.type.code === 30"
        >
          {{
            incident.playerNameShort != ""
              ? incident.playerNameShort
              : incident.playerName
          }}
        </span>
        <span
          class="text-grey-2 font-roboto-500"
          *ngIf="incident.position.code === 2 && incident.type.code === 30"
        >
          {{
            incident.playerNameShort != ""
              ? incident.playerNameShort
              : incident.playerName
          }}
        </span>

        <!-- Yelloy o Red card -->
        <span
          class="font-roboto-600"
          *ngIf="incident.type.code === 3 || incident.type.code === 4"
        >
          {{
            incident.playerNameShort != ""
              ? incident.playerNameShort
              : incident.playerName
          }}
        </span>

        <!-- Change player -->
        <span
          class="text-grey-2 font-roboto-500"
          *ngIf="incident.type.code === 9"
        >
          {{
            incident.outPlayerNameShort != ""
              ? incident.outPlayerNameShort
              : incident.outPlayerName
          }}
        </span>
        <span class="font-roboto-600" *ngIf="incident.type.code === 9">
          {{
            incident.inPlayerNameShort != ""
              ? incident.inPlayerNameShort
              : incident.inPlayerName
          }}
        </span>

        <!-- Other incidents (End halftime, endtime, add time or var info) -->
        <span
          class="text-grey-2 font-roboto-500"
          *ngIf="
            incident.type.code === 11 ||
            incident.type.code === 12 ||
            incident.type.code === 19 ||
            incident.type.code === 26 ||
            incident.type.code === 27
          "
        >
          {{ incident.type.text }}
        </span>
        <span
          class="text-grey-2 font-roboto-500"
          *ngIf="incident.type.code === 28"
        >
          {{ incident.varResult.text || incident.varReason.text }}
        </span>
        <span
          class="text-grey-2 font-roboto-500"
          *ngIf="incident.type.code === 15"
        >
          {{ incident.type.text }}
        </span>
      </div>
    </div>
  </ng-container>
</div>
